import React, { useState, useEffect } from "react";

import Modal from "react-bootstrap/Modal";

import moment from "moment";

import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";

import ContractTable from "../Contract/List/Modify.js";

import ContractComponent from "../Contract/List/Component.js";

const MasterContractModal = ({ branchId, nurseryId, bizApp, serviceAppList, appAuthTypeList, nurseryName, directorName, address, list }) => {
    const [show, setShow] = useState(false);
    const [bizAppMap, setBizAppMap] = useState(false);
    const [contractList, setContractList] = useState(false);
    const [branchName, setBranchName] = useState(false);
    useEffect(() => {
        return () => {};
    }, [branchId, nurseryId, bizApp, serviceAppList, appAuthTypeList, nurseryName, list, show]);
    const initModal = (bizApp, list) => {
        if (bizApp && list) {
            const newBizAppMap = ContractComponent.func.getBizAppMap(bizApp, onChangeBizAppFold);
            list.sort((a, b) => {
                return a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age;
            });
            setContractList(list);
            updateContractTotal(newBizAppMap, list);
        }
    };
    const updateContractTotal = (bizAppMap, list) => {
        if (bizAppMap) {
            let newBizAppMap = { ...bizAppMap };
            Object.keys(bizAppMap).forEach((a) => {
                if(a != 'totalInfo') {
                    newBizAppMap[a].count = 0;
                    newBizAppMap[a].quantity = 0;
                }
            });
            newBizAppMap['totalInfo'] = { quantity: 0 };
            let newBranchName = {};
            list.forEach((c) => {
                if (c.is555) return;
                let quantityTotalAdded = false;
                Object.keys(bizAppMap).forEach((a) => {
                    if (bizAppMap[a].info && newBizAppMap[a].info.contractUseTas && c.app_auth[a] && c[bizAppMap[a].info.quantity.field[0]] && (c.app_auth[a].approval === "AP" || c.app_auth[a].approval === "WT")) {
                        newBizAppMap[a].count++;
                        if(bizAppMap[a].hasCellQuantity) {
                            newBizAppMap[a].quantity += Number(c[bizAppMap[a].info.quantity.field[0]]);
                        } else {
                            if(!quantityTotalAdded) {
                                newBizAppMap.totalInfo.quantity += Number(c[bizAppMap[a].info.quantity.field[0]]);
                                quantityTotalAdded = true;
                            }
                        }
                        if (!newBranchName[a]) newBranchName[a] = c.app_auth[a].branch_name;
                        else if (newBranchName[a].indexOf(c.app_auth[a].branch_name) === -1) newBranchName[a] += "/" + c.app_auth[a].branch_name;
                    }
                });
            });
            setBizAppMap(newBizAppMap);
            if (!branchName) setBranchName(newBranchName);
        }
    };
    const updateContractList = (list) => {
        // list.sort((a, b) => {
        //     return a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age;
        // });
        setContractList(list);
        updateContractTotal(bizAppMap, list);
    };
    const onChangeBizAppFold = (app, bizApp, fold = undefined) => {
        let newBizAppMap = { ...bizApp };
        newBizAppMap[app].fold = fold == undefined ? !newBizAppMap[app].fold : fold;
        setBizAppMap(newBizAppMap);
    };

    const submitContract = (_list) => {
        axios({
            method: "post",
            url: `${Constant.API_DOMAIN}/api/contract/update/0/${nurseryId}`,
            data: {
                contracts: _list,
            },
        })
            .then((res) => {
                if (res.data.code === 200) {
                    alert("변경 내용이 적용 되었습니다.");
                    document.location.reload();
                } else if (res.data.code === 5001) {
                    const arr = res.data.exist_apps;
                    const names = [];
                    arr.forEach((a) => {
                        let name = "";
                        if(serviceAppList) {
                            var app = serviceAppList.find((a) => a == a.appId);
                            if(app) {
                                name = app.name;
                            }
                        }
                        if (name) names.push(name);
                    });

                    alert(`해당 원에는 이미 [${names.join(", ")}] 계약이 존재하여 계약을 등록 할 수 없습니다.`);
                    return;
                } else {
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    return;
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    return (
        <>
            <button
                className="btn btn-rounded btn-warning btn-block"
                onClick={() => {
                    initModal(bizApp, list ? JSON.parse(JSON.stringify(list)) : list);
                    setShow(true);
                }}
            >
                <i className="fas fa-check-circle mr-2" />
                계약 수정
            </button>
            <Modal
                className={`modal-contract modal-container fullscreen-modal`}
                show={show}
                // animation={false}
                onHide={() => {
                    if (window.confirm("계약 수정을 취소하시겠습니까?")) {
                        setShow(false);
                        // document.location.reload();
                    }
                }}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title font-14">계약 수정</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div className="row m-0 bg-primary-light">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 mt-2 mb-2">
                            <div className="page-header ml-2 mt-3 mb-3">
                                <h3 className="">
                                    {nurseryName}
                                    <span className="text-muted">{` (${directorName || "-"}, ${address || "-"})`}</span>
                                </h3>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12" />
                    </div>
                    <div className="div-table-contract m-0">
                        <div className="row mt-2">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <ContractTable.MasterTable
                                    tableId={"createTable"}
                                    bizApp={bizAppMap}
                                    serviceAppList={serviceAppList}
                                    appAuthTypeList={appAuthTypeList}
                                    list={contractList}
                                    setList={updateContractList}
                                    changeList={updateContractList}
                                    branchName={branchName}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row m-3">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-12" />
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-2 col-12" />
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                            <button className="btn btn-info btn-rounded btn-block" onClick={() => submitContract(contractList)}>
                                저장
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default MasterContractModal;
